/* eslint-disable react/no-danger */
// eslint-disable-next-line react/no-danger
import React from 'react';
import IconSmile from '@/assets/IconSmile.svg';

type TProps = {
  data: {
    has_icon: string;
    prefix: string;
    suffix: string;
  };
  template: string;
};

export const Header = React.memo(({ data, template }: TProps) => {
  const prefixTemplateClass = `vitrine-template${template}`;

  return (
    <>
      {data?.has_icon === 'true' ? (
        <div className={`${prefixTemplateClass}__header`}>
          <span
            className={`${prefixTemplateClass}__header--title1`}
            data-testid="prefix"
          >
            {data.prefix}
          </span>
          {data.has_icon === 'true' && (
            <span
              className={`${prefixTemplateClass}__header-icon`}
              data-testid="icon"
            >
              <img src={IconSmile} alt="Smile" />
            </span>
          )}
          <span className={`${prefixTemplateClass}__header--title2`}>
            <strong data-testid="suffix">{data.suffix}</strong>
          </span>
        </div>
      ) : null}
    </>
  );
});
